import { useEffect, useState } from "react";
import { api } from "./api";
import { cache } from "./cache";
import { DEFAULT_SERVICES } from "./defaultContent";

function bootstrapServices() {
  if (typeof window !== "undefined") {
    const arr = window.__ATC_BOOTSTRAP__?.services;
    if (Array.isArray(arr) && arr.length > 0) return arr;
  }
  return null;
}

function bootstrapTestimonials() {
  if (typeof window !== "undefined") {
    const arr = window.__ATC_BOOTSTRAP__?.testimonials;
    if (Array.isArray(arr)) return arr;
  }
  return null;
}

/**
 * Returns the list of public services, with the priority:
 *   1. inline bootstrap data (window.__ATC_BOOTSTRAP__)
 *   2. localStorage cache
 *   3. bundled DEFAULT_SERVICES
 *   4. live API (also refreshes the cache for next visit)
 */
export function useServices() {
  const [services, setServices] = useState(() => {
    const boot = bootstrapServices();
    if (boot) return boot;
    const cached = cache.get("services");
    if (Array.isArray(cached) && cached.length > 0) return cached;
    return DEFAULT_SERVICES;
  });

  useEffect(() => {
    let cancelled = false;
    api
      .get("/services")
      .then((r) => {
        if (cancelled) return;
        if (Array.isArray(r.data) && r.data.length > 0) {
          cache.set("services", r.data);
          setServices(r.data);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return services;
}

export function useTestimonials() {
  const [items, setItems] = useState(() => {
    const boot = bootstrapTestimonials();
    if (boot) return boot;
    const cached = cache.get("testimonials");
    return Array.isArray(cached) ? cached : [];
  });

  useEffect(() => {
    let cancelled = false;
    api
      .get("/testimonials")
      .then((r) => {
        if (cancelled) return;
        if (Array.isArray(r.data)) {
          cache.set("testimonials", r.data);
          setItems(r.data);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return items;
}
